import React from 'react';
import debounce from 'lodash/debounce';

function LoggerHandler(WrappedComponent) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            // When things go bad in the client, it can result in a ton of errors.
            // We don't want to blast the logger call, which can cause a 402 eventually.
            this.handleOnError = debounce(this.handleOnError.bind(this), 300);
        }

        componentDidMount() {
            window.clientErrorHandlerInitialized = true;
            // Commenting out to reduce client side logging
            window.addEventListener('error', this.handleOnError);
        }

        componentWillUnmount() {
            window.removeEventListener('error', this.handleOnError);
        }

        /* eslint-disable complexity */
        handleOnError(event = {}) {
            const errorData = {
                errorType: 'GlobalClientErrorHandler',
                originRequestMarker:
                    window && window.debugLog ? window.debugLog.requestMarker : 'unknown'
            };

            // ErrorEvent does not have enumerable attributes, so to avoid issues
            // do a special test, and take what we need.
            if (
                !!event &&
                typeof event === 'object' &&
                event.toString().indexOf('ErrorEvent') >= 0
            ) {
                // This is an error event object, so we can assume a bunch of things
                // https://developer.mozilla.org/en-US/docs/Web/API/ErrorEvent
                errorData.filename = event.filename;
                errorData.message = event.message;
                errorData.lineno = event.lineno;
                errorData.colno = event.colno;

                // We add a stack in some cases.
                if (event.error && event.error.stack) {
                    errorData.stack = event.error.stack;
                }
            } else if (!!event.error && typeof event.error === 'object') {
                if (event.error.message) {
                    errorData.message = event.error.message;
                }
                if (event.error.stack) {
                    errorData.stack = event.error.stack;
                }
            } else if (typeof event.error === 'string') {
                errorData.message = event.error;
            }

            // LISTING-957 - Going to log out all errors to console for
            // the time being, so we can see them in glassbox.
            console.log('ErrorHandler: ', errorData); // eslint-disable-line
            this.props.actions.logToServer(errorData);
        }
        /* eslint-enable complexity */

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}

export default LoggerHandler;
